module.exports = __webpack_public_path__ + "./tseng-illustration_1226adfd29ca0a6b5b1454f330c14989.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2016/tseng-illustration.png
// module id = 438
// module chunks = 0